import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CurrentAccountBawag } from './product/bawag-ca/currentAccount-bawag.component';
import { CardsEasyComponent } from "./product/cards-easy/cards-easy.component";
import { CardsComponent } from "./product/cards/cards.component";
import { DepoEasyInvestComponent } from "./product/depo-easy-invest/depo-easy-invest.component";
import { DepoEasyComponent } from "./product/depo-easy/depo-easy.component";
import { DepoComponent } from "./product/depo/depo.component";
import { CurrentAccountEasy } from './product/easy-ca/currentAccount-easy.component';
import { EasyMetalCardUpgradeComponent } from './product/easy-metal-card-upgrade/easy-metal-card-upgrade.component';
import { CurrentAccountEasyKids } from './product/easykids-ca/currentAccount-easykids.component';
import { FtlEasyComponent } from "./product/ftl-easy/ftl-easy.component";
import { FtlComponent } from "./product/ftl/ftl.component";
import { JointAccountEasyComponent } from './product/joint-account-easy/joint-account-easy.component';
import { LendingEasyComponent } from './product/lending-easy/lending-easy.component';
import { LendingComponent } from './product/lending/lending.component';
import { ProductSwitchEasyComponent } from './product/product-switch-easy/product-switch-easy.component';
import { ProductSwitchComponent } from './product/product-switch/product-switch.component';
import { SavingEasyComponent } from "./product/saving-easy/saving-easy.component";
import { SavingComponent } from "./product/saving/saving.component";
import { SspEasyComponent } from './product/ssp-easy/ssp-easy.component';
import { SspComponent } from './product/ssp/ssp.component';
import { WrappedCampaignEasyComponent } from './product/wrapped-campaign-easy/wrapped-campaign-easy.component';
import { WrappedCampaignComponent } from './product/wrapped-campaign/wrapped-campaign.component';

const routes: Routes = [
  { path: 'depo', component: DepoComponent },
  { path: 'savings', component: SavingComponent },

  { path: 'savings-easy', component: SavingEasyComponent },
  { path: 'ftl', component: FtlComponent },
  { path: 'ftl-easy', component: FtlEasyComponent },
  { path: 'cards', component: CardsComponent },
  { path: 'cards-easy', component: CardsEasyComponent },
  { path: 'currentAccount-bawag', component: CurrentAccountBawag },
  { path: 'currentAccount-bawag/:channel', component: CurrentAccountBawag },
  { path: 'currentAccount-easy', component: CurrentAccountEasy },
  { path: 'currentAccount-easy/:channel', component: CurrentAccountEasy },
  { path: 'currentAccount-easy-kids', component: CurrentAccountEasyKids },
  { path: 'currentAccount-easy-kids/:channel', component: CurrentAccountEasyKids },
  { path: 'lending', component: LendingComponent},
  { path: 'lending-easy', component: LendingEasyComponent },
  { path: 'ssp', component: SspComponent },
  { path: 'ssp/:formName', component: SspComponent },
  { path: 'easy-ssp', component: SspEasyComponent },
  { path: 'easy-ssp/:formName', component: SspEasyComponent },
  { path: 'product-switch', component: ProductSwitchComponent },
  {
    path: 'product-switch-easy/kids-youth',
    component: ProductSwitchEasyComponent,
    data: { redirectPath: 'kids-youth' }
  },
  {
    path: 'product-switch-easy/youth',
    redirectTo: 'product-switch-easy/kids-youth',
    pathMatch: 'full'
  },
  { path: 'product-switch-easy', component: ProductSwitchEasyComponent },
  { path: 'portfolio-easy', component: WrappedCampaignEasyComponent },
  { path: 'portfolio', component: WrappedCampaignComponent },
  { path: 'easy-metal', component: EasyMetalCardUpgradeComponent },
  { path: 'depo-easy', component: DepoEasyInvestComponent },
  { path: 'easy-depo', component: DepoEasyComponent },
  { path: 'joint', component: JointAccountEasyComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
